import { addMessages } from '@hana/i18n';

// Khoá chuỗi cadv.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'cadv.1': "Quyết toán theo người ↗",
});
addMessages('en', {
  'cadv.1': "Settle by person ↗",
});
